
// import React, { useState } from "react";
// // Fetch the usertypeid from local storage





// function AffiliateCampaignInvite({ campaign, onClose }) {
//   const [copied, setCopied] = useState(false);
//   const usertypeid = localStorage.getItem("usertypeid");




//   if (!campaign) {
//     return (
//       <div className="text-center mt-5">
//         <h5>No campaign data found.</h5>
//       </div>
//     );
//   }


//   // const { campaign_name, description, commission, target_url,  password, campaign_id,affiliate_user_id, affiliated_campaign_id } =
//   //   campaign ;
//   // const generatedUrl = `${target_url}?campaign_id=${campaign_id}&affiliate_user_id=${affiliate_user_id}&affiliated_campaign_id=${affiliated_campaign_id}`;


//  const {
//     campaign_name,
//     description,
//     commission,
//     target_url,
//     campaign_id,
//     affiliate_user_id,          // returned from backend merge
//     affiliated_campaign_id,     // returned from backend (insertId)
//   } = campaign;

//   // Fallback: if affiliate_user_id is not present, try localStorage
//   // const affiliateId = affiliate_user_id || localStorage.getItem("usertypeid");

//   // const generatedUrl = `${target_url}?campaign_id=${campaign_id}&affiliate_user_id=${affiliateId}&affiliated_campaign_id=${affiliated_campaign_id}`;

 
// const affiliateId = affiliate_user_id || localStorage.getItem("usertypeid");

// const encodedCampaignId = btoa(String(campaign_id));
// const encodedAffiliateId = btoa(String(affiliateId));
// const encodedAffiliatedCampaignId = btoa(String(affiliated_campaign_id));

// const generatedUrl = `${target_url}?campaign_id=${encodedCampaignId}&affiliate_user_id=${encodedAffiliateId}&affiliated_campaign_id=${encodedAffiliatedCampaignId}`;

//   const handleCopy = () => {
//     navigator.clipboard.writeText(generatedUrl);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 1500);
//   };

//   return (
//     <div
//       style={{
//         fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//         backgroundColor: "#f8f9fa", // same as popup background
//         padding: "30px 40px",
//         position: "relative",
//       }}
//     >
//       {/* Close button */}
//       <button
//         onClick={onClose}
//         style={{
//           position: "absolute",
//           top: "20px",
//           right: "20px",
//           background: "transparent",
//           border: "none",
//           fontSize: "22px",
//           color: "#333",
//           cursor: "pointer",
//         }}
//       >
//         Close
//       </button>

//       <div style={{ textAlign: "center", marginTop: "10px" }}>
//         <h2
//           style={{
//             display: "inline-block",
//             background: "#000",
//             color: "#fff",
//             padding: "10px 25px",
//             borderRadius: "5px",
//             fontSize: "20px",
//           }}
//         >
//           Brand Logo
//         </h2>
//       </div>

//       <div style={{ marginTop: "35px", textAlign: "center" }}>
//         <h2 style={{ fontWeight: "700", fontSize: "24px", color: "#222" }}>
//           Join Our New Affiliate Campaign
//         </h2>

//         <p style={{ color: "#555", marginTop: "10px", marginBottom: "20px" }}>
//           Hello Partner,
//         </p>

//         <p
//           style={{
//             color: "#555",
//             lineHeight: "1.8",
//             fontSize: "15.5px",
//             marginBottom: "25px",
//           }}
//         >
//           We’re thrilled to invite you to participate in our latest affiliate campaign:
//           <strong> {campaign_name}</strong>. This program helps you grow your
//           earnings while promoting products your audience will love.
//         </p>

//         <ul
//           style={{
//             textAlign: "left",
//             display: "inline-block",
//             lineHeight: "1.9",
//             color: "#333",
//             fontSize: "15.5px",
//           }}
//         >
//           <li>
//             Earn up to <strong>{commission || "N/A"}</strong> commission per referral
//           </li>
//           <li>Access exclusive creative assets and tracking tools</li>
//           <li>Get performance insights and timely payouts</li>
//         </ul>

//         {description && (
//           <p style={{ marginTop: "20px", fontStyle: "italic", color: "#666" }}>
//             “{description}”
//           </p>
//         )}



//                 {/* Generated URL */}
//         <div
//           style={{
//             backgroundColor: "#e9ecef",
//             marginTop: "30px",
//             padding: "15px",
//             borderRadius: "6px",
//             fontSize: "13.5px",
//             color: "#333",
//             wordBreak: "break-all",
//             border: "1px solid #d6d8db",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             gap: "10px",
//           }}
//         >
//           <span style={{ fontFamily: "monospace", flex: 1 }}>
//             {generatedUrl}
//           </span>
//           <button
//             onClick={handleCopy}
//             style={{
//               backgroundColor: copied ? "#28a745" : "#007bff",
//               color: "#fff",
//               border: "none",
//               padding: "6px 10px",
//               borderRadius: "4px",
//               fontSize: "13px",
//               cursor: "pointer",
//               minWidth: "90px",
//             }}
//           >
//             {copied ? "Link Copied!" : "Copy URL"}
//           </button>
//         </div>

//         {/* Start Campaign Button */}
//         <div style={{ marginTop: "30px" }}>
//           <button
//             onClick={onClose}
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{
//               backgroundColor: "#007bff",
//               color: "#fff",
//               padding: "12px 28px",
//               borderRadius: "5px",
//               textDecoration: "none",
//               fontWeight: "600",
//               fontSize: "16px",
//             }}
//           >
//             Start Campaign
//           </button>
//         </div>



//         <p style={{ marginTop: "25px", fontSize: "14.5px", color: "#777" }}>
//           Have questions? Reach out at{" "}
//           <a href="mailto:support@example.com" style={{ color: "#007bff" }}>
//             support@example.com
//           </a>
//         </p>

//         <div
//           style={{
//             marginTop: "30px",
//             fontSize: "13px",
//             color: "#999",
//             paddingTop: "15px",
//             borderTop: "1px solid #ddd",
//           }}
//         >
//           © 2025 Example Brand • 123 Market Street, San Francisco, CA
//           <br />
//           <a href="#" style={{ color: "#888", textDecoration: "none" }}>
//             Unsubscribe
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AffiliateCampaignInvite;
// import React, { useState } from "react";
// import PopupWrapper from "./PopupWrapper";

// function AffiliateCampaignInvite({ campaign, onClose }) {
//   const [copied, setCopied] = useState(false);

//   if (!campaign) {
//     return (
//       <PopupWrapper onClose={onClose}>
//         <div style={{ padding: "20px", textAlign: "center" }}>
//           <h5>No campaign data found.</h5>
//         </div>
//       </PopupWrapper>
//     );
//   }

//  const {
//   campaign_name = "Active Campaign",
//   description = "",
//   commission = "10%",
//   target_url = "https://example.com",
//   campaign_id,
//   affiliate_user_id,
//   affiliated_campaign_id = 1,
// } = campaign;


//   const affiliateId = affiliate_user_id || localStorage.getItem("usertypeid");

//   const generatedUrl = `${target_url}?campaign_id=${btoa(
//     campaign_id
//   )}&affiliate_user_id=${btoa(affiliateId)}&affiliated_campaign_id=${btoa(
//     affiliated_campaign_id
//   )}`;

//   const handleCopy = () => {
//     navigator.clipboard.writeText(generatedUrl);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 1500);
//   };

//   return (
//     <PopupWrapper onClose={onClose}>
//      <div
//       style={{
//         fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//         backgroundColor: "#f8f9fa", // same as popup background
//         padding: "30px 40px",
//         position: "relative",
//       }}
//     >
//       {/* Close button */}
//       <button
//         onClick={onClose}
//         style={{
//           position: "absolute",
//           top: "20px",
//           right: "20px",
//           background: "transparent",
//           border: "none",
//           fontSize: "22px",
//           color: "#333",
//           cursor: "pointer",
//         }}
//       >
//         Close
//       </button>

//       <div style={{ textAlign: "center", marginTop: "10px" }}>
//         <h2
//           style={{
//             display: "inline-block",
//             background: "#000",
//             color: "#fff",
//             padding: "10px 25px",
//             borderRadius: "5px",
//             fontSize: "20px",
//           }}
//         >
//           Brand Logo
//         </h2>
//       </div>

//       <div style={{ marginTop: "35px", textAlign: "center" }}>
//         <h2 style={{ fontWeight: "700", fontSize: "24px", color: "#222" }}>
//           Join Our New Affiliate Campaign
//         </h2>

//         <p style={{ color: "#555", marginTop: "10px", marginBottom: "20px" }}>
//           Hello Partner,
//         </p>

//         <p
//           style={{
//             color: "#555",
//             lineHeight: "1.8",
//             fontSize: "15.5px",
//             marginBottom: "25px",
//           }}
//         >
//           We’re thrilled to invite you to participate in our latest affiliate campaign:
//           <strong> {campaign_name}</strong>. This program helps you grow your
//           earnings while promoting products your audience will love.
//         </p>

//         <ul
//           style={{
//             textAlign: "left",
//             display: "inline-block",
//             lineHeight: "1.9",
//             color: "#333",
//             fontSize: "15.5px",
//           }}
//         >
//           <li>
//             Earn up to <strong>{commission || "N/A"}</strong> commission per referral
//           </li>
//           <li>Access exclusive creative assets and tracking tools</li>
//           <li>Get performance insights and timely payouts</li>
//         </ul>

//         {description && (
//           <p style={{ marginTop: "20px", fontStyle: "italic", color: "#666" }}>
//             “{description}”
//           </p>
//         )}



//                 {/* Generated URL */}
//         <div
//           style={{
//             backgroundColor: "#e9ecef",
//             marginTop: "30px",
//             padding: "15px",
//             borderRadius: "6px",
//             fontSize: "13.5px",
//             color: "#333",
//             wordBreak: "break-all",
//             border: "1px solid #d6d8db",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             gap: "10px",
//           }}
//         >
//           <span style={{ fontFamily: "monospace", flex: 1 }}>
//             {generatedUrl}
//           </span>
//           <button
//             onClick={handleCopy}
//             style={{
//               backgroundColor: copied ? "#28a745" : "#007bff",
//               color: "#fff",
//               border: "none",
//               padding: "6px 10px",
//               borderRadius: "4px",
//               fontSize: "13px",
//               cursor: "pointer",
//               minWidth: "90px",
//             }}
//           >
//             {copied ? "Link Copied!" : "Copy URL"}
//           </button>
//         </div>

//         {/* Activate Campaign Button */}
//         <div style={{ marginTop: "30px" }}>
//           <button
//             onClick={onClose}
//             style={{
//               backgroundColor: "#28a745",
//               color: "#fff",
//               padding: "12px 28px",
//               borderRadius: "5px",
//               border: "none",
//               fontWeight: "600",
//               fontSize: "16px",
//               cursor: "pointer",
//             }}
//           >
//             Activate Campaign
//           </button>
//         </div>



//         <p style={{ marginTop: "25px", fontSize: "14.5px", color: "#777" }}>
//           Have questions? Reach out at{" "}
//           <a href="mailto:support@example.com" style={{ color: "#007bff" }}>
//             support@example.com
//           </a>
//         </p>

//         <div
//           style={{
//             marginTop: "30px",
//             fontSize: "13px",
//             color: "#999",
//             paddingTop: "15px",
//             borderTop: "1px solid #ddd",
//           }}
//         >
//           © 2025 Example Brand • 123 Market Street, San Francisco, CA
//           <br />
//           <a href="#" style={{ color: "#888", textDecoration: "none" }}>
//             Unsubscribe
//           </a>
//         </div>
//       </div>
//     </div>
  

//     </PopupWrapper>
//   );
// }

// export default AffiliateCampaignInvite;
// src/Components/MENU/HRMS/AffiliateCampaignInvite.jsx
import React, { useState } from "react";
import PopupWrapper from "./PopupWrapper";
import { postData } from "../../../global/Globalapi"; // assumes same helper you use elsewhere

/**
 * Props:
 *  - campaign: {
 *      campaign_name,
 *      description,
 *      commission,
 *      target_url,            // may be product page url (e.g. /product/OA==) or activation url
 *      campaign_id,           // could be plain or encoded depending on how you pass it
 *      affiliate_user_id,     // may be provided by query params or backend
 *      affiliated_campaign_id // empty string or null if not activated yet
 *      product_id             // optional, base64 encoded or plain ID
 *    }
 *  - onClose: function to close popup
 *
 * Behavior:
 *  - If affiliated_campaign_id is empty -> show Activate Campaign button
 *  - Clicking Activate calls backend (/affiliateCampaign/join) to create affiliated_campaign_id
 *  - On success, popup switches to normal mode showing the generated URL and copy button
 *  - After activation this component will redirect to the final product URL with encoded params.
 */

function AffiliateCampaignInvite({ campaign = {}, onClose }) {
  const [copied, setCopied] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  // local state to reflect activation result
  const [affId, setAffId] = useState(
    campaign.affiliated_campaign_id === undefined ? "" : campaign.affiliated_campaign_id
  );

  // fallback values
  const {
    campaign_name = "Active Campaign",
    description = "",
    commission = "10%",
    target_url = "https://example.com",
    campaign_id,
    affiliate_user_id,
    product_id, // optional, if you pass product_id (encoded) use it
  } = campaign;

  // affiliate id fallback from localStorage
  const affiliateId = affiliate_user_id || localStorage.getItem("usertypeid");

  // Helper to build final product URL with encoded params
  const buildFinalUrl = (affiliatedCampaignId) => {
    // determine product base:
    // priority: 1) if product_id prop exists, use /product/{product_id}
    //           2) else try to extract product id from target_url (if it contains /product/)
    //           3) else use target_url directly
    let productBase = target_url;

    if (product_id) {
      // product_id might already be base64 (like OA==) — assume it's ready for URL
      productBase = `${window.location.origin}/product/${product_id}`;
    } else {
      // detect if target_url contains "/product/"
      try {
        const u = new URL(target_url, window.location.origin);
        if (u.pathname.includes("/product/")) {
          productBase = `${window.location.origin}${u.pathname}`;
        } else {
          // fallback to target_url as is (may be full product link)
          productBase = target_url;
        }
      } catch (e) {
        // if target_url is relative like "/product/OA=="
        if (target_url.includes("/product/")) {
          productBase = `${window.location.origin}${target_url}`;
        } else {
          productBase = target_url;
        }
      }
    }

    // encode each param using btoa for consistency with your other code
    const encCampaignId = btoa(String(campaign_id || ""));
    const encAffiliateId = btoa(String(affiliateId || ""));
    const encAffiliatedId = btoa(String(affiliatedCampaignId || ""));

    // If productBase already contains query params, choose & otherwise ?
    const separator = productBase.includes("?") ? "&" : "?";

    return `${productBase}${separator}campaign_id=${encCampaignId}&affiliate_user_id=${encAffiliateId}&affiliated_campaign_id=${encAffiliatedId}`;
  };

  const generatedUrl = affId ? buildFinalUrl(affId) : `${target_url}?campaign_id=${btoa(String(campaign_id || ""))}&affiliate_user_id=${btoa(String(affiliateId || ""))}&affiliated_campaign_id=`;

  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(generatedUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  // Activate campaign: calls your backend to create the affiliated campaign record.
  // Uses same endpoint as in your dashboard: POST /affiliateCampaign/join
  const handleActivate = async () => {
    setError("");
    setBusy(true);

    try {
      const payload = {
        affiliate_user_id: Number(affiliateId),
        campaign_id: Number(campaign_id),
      };

      // Reuse the same join endpoint you used in list page
      const res = await postData("/affiliateCampaign/join", payload);

      // Expected structure: res.data.affiliated_campaign_id (or similar)
      const newData = res?.data;
      const newAffId = newData?.affiliated_campaign_id || newData?.affiliated_campaign_id || newData?.affiliate_campaign_id || newData?.insertId || "";

      if (!newAffId) {
        // If backend returns a different shape, adapt here.
        setError("Activation succeeded but server did not return affiliated_campaign_id.");
        setBusy(false);
        return;
      }

      // update local state and show final UI
      setAffId(String(newAffId));
      setBusy(false);

      // Redirect to final product page with full encoded params (you asked for automatic redirect)
      const finalUrl = buildFinalUrl(newAffId);
      // Small delay to let user see confirmation; remove if you prefer immediate redirect
      setTimeout(() => {
        window.location.href = finalUrl;
      }, 600);
    } catch (err) {
      console.error("Activation error:", err);
      setError("Failed to activate. Please try again.");
      setBusy(false);
    }
  };

  return (
    <PopupWrapper onClose={onClose}>
      <div
        style={{
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          backgroundColor: "#f8f9fa",
          padding: "30px 40px",
          position: "relative",
          maxWidth: 820,
          margin: "0 auto",
        }}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            background: "transparent",
            border: "none",
            fontSize: "22px",
            color: "#333",
            cursor: "pointer",
          }}
          aria-label="Close"
        >
          Close
        </button>

        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <h2
            style={{
              display: "inline-block",
              background: "#000",
              color: "#fff",
              padding: "10px 25px",
              borderRadius: "5px",
              fontSize: "20px",
            }}
          >
            Brand Logo
          </h2>
        </div>

        <div style={{ marginTop: "35px", textAlign: "center" }}>
          <h2 style={{ fontWeight: "700", fontSize: "24px", color: "#222" }}>
            Join Our New Affiliate Campaign
          </h2>

          <p style={{ color: "#555", marginTop: "10px", marginBottom: "20px" }}>
            Hello Partner,
          </p>

          <p
            style={{
              color: "#555",
              lineHeight: "1.8",
              fontSize: "15.5px",
              marginBottom: "25px",
            }}
          >
            We’re thrilled to invite you to participate in our latest affiliate campaign:
            <strong> {campaign_name}</strong>. This program helps you grow your
            earnings while promoting products your audience will love.
          </p>

          <ul
            style={{
              textAlign: "left",
              display: "inline-block",
              lineHeight: "1.9",
              color: "#333",
              fontSize: "15.5px",
            }}
          >
            <li>
              Earn up to <strong>{commission || "N/A"}</strong> commission per referral
            </li>
            <li>Access exclusive creative assets and tracking tools</li>
            <li>Get performance insights and timely payouts</li>
          </ul>

          {description && (
            <p style={{ marginTop: "20px", fontStyle: "italic", color: "#666" }}>
              “{description}”
            </p>
          )}

          {/* Error message */}
          {error && (
            <div style={{ color: "crimson", marginTop: 18, fontWeight: 600 }}>
              {error}
            </div>
          )}

          {/* If not activated yet, show Activate button */}
          {!affId ? (
            <div style={{ marginTop: 40 }}>
              <button
                onClick={handleActivate}
                disabled={busy}
                style={{
                  backgroundColor: busy ? "#94d3a2" : "#28a745",
                  color: "#fff",
                  padding: "14px 32px",
                  borderRadius: "5px",
                  border: "none",
                  fontWeight: "600",
                  fontSize: "18px",
                  cursor: busy ? "wait" : "pointer",
                }}
              >
                {busy ? "Activating..." : "Activate Campaign"}
              </button>

              <p style={{ marginTop: 16, color: "#777", fontSize: 14 }}>
                This will create your affiliate campaign ID and then redirect you to the product page with your unique link.
              </p>
            </div>
          ) : (
            <>
              {/* Generated URL Box */}
              <div
                style={{
                  backgroundColor: "#e9ecef",
                  marginTop: "30px",
                  padding: "15px",
                  borderRadius: "6px",
                  fontSize: "13.5px",
                  color: "#333",
                  wordBreak: "break-all",
                  border: "1px solid #d6d8db",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <span style={{ fontFamily: "monospace", flex: 1 }}>
                  {generatedUrl}
                </span>
                <button
                  onClick={handleCopy}
                  style={{
                    backgroundColor: copied ? "#28a745" : "#007bff",
                    color: "#fff",
                    border: "none",
                    padding: "6px 10px",
                    borderRadius: "4px",
                    fontSize: "13px",
                    cursor: "pointer",
                    minWidth: "90px",
                  }}
                >
                  {copied ? "Link Copied!" : "Copy URL"}
                </button>
              </div>

              {/* Start Campaign Button */}
              <div style={{ marginTop: "30px" }}>
                <a
                  href={generatedUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#007bff",
                    color: "#fff",
                    padding: "12px 28px",
                    borderRadius: "5px",
                    fontWeight: "600",
                    fontSize: "16px",
                    textDecoration: "none",
                    display: "inline-block",
                  }}
                >
                  Start Campaign
                </a>
              </div>
            </>
          )}

          <p style={{ marginTop: "25px", fontSize: "14.5px", color: "#777" }}>
            Have questions? Reach out at{" "}
            <a href="mailto:support@example.com" style={{ color: "#007bff" }}>
              support@example.com
            </a>
          </p>

          <div
            style={{
              marginTop: "30px",
              fontSize: "13px",
              color: "#999",
              paddingTop: "15px",
              borderTop: "1px solid #ddd",
            }}
          >
            © 2025 Example Brand • 123 Market Street
            <br />
            <a href="#" style={{ color: "#888", textDecoration: "none" }}>
              Unsubscribe
            </a>
          </div>
        </div>
      </div>
    </PopupWrapper>
  );
}

export default AffiliateCampaignInvite;
